import React from 'react';
import {BreadCrumbs} from '../components/common/bread-crumbs/BreadCrumbs';
import {Header} from '../components/g2/header/Header';
import {Banner} from '../components/common/banner/Banner';
import {SEOText} from '../components/g2/seo-text/SEOText';
import {SEOTextRevised} from '../components/g2/seo-text/SEOTextRevised';
import {LinkPiles} from '../components/common/linkpiles/LinkPiles';
import {PopularDestinations} from '../components/g2/popular-destinations/PopularDestinations';
import {PropertyTypes} from '../components/g2/property-types/PropertyTypes';
import {GreatPlacesToStay} from '../components/g2/great-places-to-stay/GreatPlacesToStay';
import DateModal from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../components/common/destination-urgency/AsyncDestinationUrgency';
import {AsyncDestinationInfographic} from '../components/common/destination-infographic/AsyncDestinationInfographic';
import {AsyncQuickSeRPFilters} from '../components/common/quick-serp-filters/AsyncQuickSeRPFilters';
import {AsyncReviews} from '../components/common/review/AsyncReviews';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import {AsyncSiteHeader} from '../components/common/site-header/AsyncSiteHeader';
import {AsyncSiteFooter} from '../components/common/site-footer/AsyncSiteFooter';
import {BackToTopComponent} from '../components/common/back-to-top-button/BackToTopComponent';
import {AsyncTrustpilot} from '../components/common/trustpilot/AsyncTrustpilot';

import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import {TESTS} from '../utils/abacus';
import LazyLoad from '../components/common/lazy-image/react-lazyload';

export const Template = () => (
    <React.Fragment>
        {withErrorBoundary(
            <MvtTest test={TESTS.WHITE_HEADER} report reportOnMount>
                <AsyncSiteHeader />
            </MvtTest>
        )}
        <Header />
        <main className="app-main">
            <BreadCrumbs />
            {withErrorBoundary(<AsyncDestinationUrgency />)}
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncQuickSeRPFilters /></LazyLoad>)}
            <PopularDestinations />
            <PropertyTypes />
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncTrustpilot /></LazyLoad>)}
            <GreatPlacesToStay />
            {withErrorBoundary(<LazyLoad once offset={250} ><AsyncReviews /></LazyLoad>)}
            {withErrorBoundary(<AsyncDestinationInfographic />)}
            <SEOTextRevised />
            <div className="container module banner-container">
                <Banner />
            </div>
            <SEOText />
            <LinkPiles />
            <BackToTopComponent />
            <DateModal />
        </main>
        <MmgLinks />
        {withErrorBoundary(<AsyncSiteFooter />)}
    </React.Fragment>
);
